export enum TemplateSource {
  FIRM = 'firm',
  Clio = 'clio',
  CLIO_TRANSFERRED = 'clio_transferred',
}
